import assert from 'minimalistic-assert'

import { createUnsignedTxForSend } from './create-unsigned-tx-for-send.js'

export const getFeeAsyncFactory = ({ api }) => {
  assert(api, 'api is required')
  return async ({ asset, feeData, unsignedTx: providedUnsignedTx, amount, toAddress, ...rest }) => {
    const unsignedTx =
      providedUnsignedTx ||
      (await createUnsignedTxForSend({
        asset,
        feeData,
        api,
        amount: amount ?? asset.currency.baseUnit(1),
        toAddress: toAddress ?? rest.fromAddress,
        useFeePayer: false,
        ...rest,
      }))

    return { fee: asset.feeAsset.currency.baseUnit(unsignedTx.txMeta.fee), unsignedTx }
  }
}

export const getFeeFactory =
  ({ asset }) =>
  ({ feeData }) => {
    return { fee: feeData.fee }
  }
